import {Grid} from "@mui/material";
import React, {useMemo} from "react";
import {Route, Routes} from "react-router-dom";
import {getCustomerVerificationSteps, resolveCustomer} from "@/services/customer.ts";
import AccountBilling from "./Billing";
import AccountInformation from "./Information";
import AccountOrganization from "./Organization";
import AccountApiKeys from "./ApiKeys";
import FaceOutlinedIcon from '@mui/icons-material/FaceOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import {LoadingBackdrop} from "@/components/Layout/DefaultLayout";
import Utils from "@/components/Shared/Utils";
import { getUserInfo } from "@/services/auth";

export default function Account() {
    const {data: customer} = resolveCustomer();
    const {data: user} = getUserInfo();

    const {data} = getCustomerVerificationSteps()

    const sidebar = useMemo(() => ({
        name: '@MyAccount',
        uuid: customer?.customer_id,
        provider: '',
        paths: [
            {
                name: 'Information',
                key: 'account/information',
                slug: `/account/information`,
                icon: FaceOutlinedIcon,
                disabled: false,
                beta: false,
                items: [
                    {
                        name: 'Profile',
                        key: 'account/information#profile',
                        slug: `/account/information#profile`,
                        icon: null,
                        disabled: false,
                        beta: false,
                    },
                    {
                        name: 'Change Password',
                        key: 'account/information#changepw',
                        slug: `/account/information#changepw`,
                        icon: null,
                        disabled: false,
                        beta: false,
                    },
                    {
                        name: '2FA',
                        key: 'account/information#mfactor',
                        slug: `/account/information#mfactor`,
                        icon: null,
                        disabled: false,
                        beta: true,
                    },
                    {
                        name: 'App Settings',
                        key: 'account/information#settings',
                        slug: `/account/information#settings`,
                        icon: null,
                        disabled: false,
                        beta: false,
                    }
                ]
            },
            {
                name: 'Billing',
                key: 'account/billing',
                slug: '',
                icon: AccountBalanceWalletOutlinedIcon,
                disabled: false,
                beta: false,
                items: [
                    {
                        name: 'Overview',
                        key: 'account/billing',
                        slug: `/account/billing`,
                        icon: null,
                        disabled: false,
                        beta: false,
                    },
                    {
                        name: 'Invoice',
                        key: 'account/billing#invoice',
                        slug: `/account/billing#invoice`,
                        icon: null,
                        disabled: false,
                        beta: false,
                    },
                    {
                        name: 'Cost Management',
                        key: 'account/cost-management',
                        slug: `/account/cost-management`,
                        icon: null,
                        disabled: true,
                        beta: true,
                    }
                ]
            },
            {
                name: 'API Keys',
                key: 'account/apikeys',
                slug: `/account/apikeys`,
                icon: VpnKeyOutlinedIcon,
                disabled: false,
                beta: false,
                items: []
            },
            {
                name: 'Organization',
                key: 'organization',
                slug: '',
                icon: CorporateFareOutlinedIcon,
                disabled: false,
                beta: false,
                items: [
                    {
                        name: 'Teams',
                        key: 'organization',
                        slug: `/account/organization`,
                        icon: null,
                        disabled: false,
                        beta: true,
                    },
                    {
                        name: 'Projects',
                        key: 'organization/projects',
                        slug: '',
                        icon: null,
                        disabled: true,
                        beta: false,
                    }
                ]
            }
        ]
    }), [customer])

    return (
        <Grid container>
            <Utils.LayoutUtils.MainSidebar {...sidebar} />
            <React.Suspense fallback={<LoadingBackdrop/>}>
                <Routes>
                    <Route path="information" element={<AccountInformation customer={customer} user={user}/>}/>
                    <Route path="billing/*" element={<AccountBilling customer={customer} user={user}/>}/>
                    <Route path="apikeys" element={<AccountApiKeys customer={customer} user={user}/>}/>
                    <Route path="organization/*"
                           element={<AccountOrganization customer={customer} user={user} invitation={data?.invitation}/>}/>
                </Routes>
            </React.Suspense>
        </Grid>
    )
}